// NewIqacSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom'; 
import { Link } from 'react-router-dom'

const NewIqacSidebar = () => {
  return (
     <div className='side_bar_iqac'>
                              <div className='side_barlogo'>
                                  <div className='newlogo'>
                                      <Link to="/">
                                                                  <img src="/assets/img/logo/mvn-university-logo-white.png" alt="img"  sx={{ backgroundBlendMode: 'lighten'}}/>
                                                              </Link>
                                  </div>

                                  <div className='side_social_logo'>
                                      <ul>
                                           <li><a href=""> <i class="fas fa-globe"></i> </a></li>
                                          <li><a href=""> <i class="fab fa-facebook-f"></i></a></li>
                                          <li><a href=""> <i class="fab fa-linkedin"></i> </a></li>
                                         
                                          <li><a href=""> <i class="fab fa-instagram"></i> </a></li>
                                      </ul>
                                  </div>


                                  <div className='iqac_new_side_linking'>
                                      <ul>
                                         
                                          <li><a href="/iqac1"><span> <i class="fas fa-globe"></i>  Home</span> </a></li>
                                          <li className='has_submenu'>
                                              <a href="javascript:void(0)"> <span><i class="fas fa-users"></i> About</span> <i class="fas fa-angle-down"></i> </a>
                                              <ul>
                                                 <li><a href="/iqac1/IQACObjectivesBenefits"> About IQAC </a></li>
                                                 <li><a target='_blank' href="/assets/img/Meetings-of-IQAC_upto-04.06.2025.pdf"> IQAC Meetings </a></li>
                                              </ul>
                                          </li>
                                          <li className='has_submenu'>
                                              <a href="javascript:void(0)"> <span><i class="fas fa-ankh"></i> NIRF</span> <i class="fas fa-angle-down"></i> </a>
                                              <ul>
                                                 <li><a href="/iqac1/NIRFRankingStatus"> NIRF Ranking Status</a></li>
                                                 {/* <li><a target='_blank' href="/assets/img/NIRF_2022_Participating.pdf"> NIRF - 2022 - Participating </a></li>
                                                 <li><a target='_blank' href="/assets/img/NIRF_2023_Participating.pdf"> NIRF - 2023 - Participating </a></li>
                                                 <li><a target='_blank' href="/assets/img/NIRF_2024_Participating.pdf"> NIRF - 2024 - Participating </a></li> */}
                                              </ul>
                                          </li>
                                          <li className='has_submenu'>
                                              <a href="/iqac1/SDG"><span> <i class="fab fa-renren"></i> Sustainable Development Goal </span></a>
                                              {/* <ul>
                                                 <li><a href="/iqac1/SDG"> SDG</a></li>
                                              </ul> */}
                                          </li>
                                          <li className='has_submenu'>
                                              <a href="/iqac1/Accreditations"><span> <i class="fas fa-certificate"></i>Recognitions and Accreditations </span></a>
                                              {/* <ul>
                                                 <li><a target='_blank' href="/assets/img/UGC-Letter-2023.pdf"> UGC Letter</a></li>
                                              </ul> */}
                                          </li>
                                          <li className='has_submenu'>
                                              <a href="/iqac1/Affiliation"><span> <i class="far fa-star"></i> Affiliation/ Ranking</span> </a>
                                              {/* <ul>
                                                 <li><a target='_blank' href="/assets/img/BAR-Council.pdf"> BAR Council</a></li>
                                                 <li><a target='_blank' href="/assets/img/State-Council-for-Physiotherapy.pdf"> State Council for Physiotherapy</a></li>
                                              </ul> */}
                                          </li>
                                          <li><a href="/iqac1/InstitutionalDevelopmentPlan"><span> <i class="fas fa-street-view"></i> Institutional Development Plan </span> </a></li>
                                          <li><a target='_blank' href="/assets/img/Value-Added-Course.pdf"> <span><i class="fas fa-book"></i> Value Added Course </span> </a></li>
                                          <li><a href="javascript:void(0)"><span> <i class="fas fa-globe"></i> Act and Status or MOA</span>  </a></li> 
                                        <li><a target='_blank' href="/assets/img/Appointment_of_Ombudsman.pdf"><span> <i class="fas fa-book"></i> Appointment of Ombudsman</span> </a></li>
                                      </ul>
                                  </div>





                              </div>



                          </div>
  );
};

export default NewIqacSidebar;
